import React from "react";

export const getValueBaseOnLanguage = (
    objectEntity,
    key = {
        en: "en",
        kh: "kh"
    }
) => {
    const language = localStorage.getItem("LANG");
    let languageKey = key.kh;
    if (language === "en") {
        languageKey = key.en;
    }
    return objectEntity?.[languageKey]
        ? objectEntity?.[languageKey]
        : objectEntity?.[key.kh];
};
